import { instance } from './axios.instance';

/**
 * Banque de modèles de Carte info vue d'ensemble, hors document : l'écran
 * d'admin embarqué en iframe dans le costing (cf. cardBankApp.jsx et
 * Api::Proposals::CardStylesController).
 *
 * À ne pas confondre avec `getCardBank` (requests/documentDatas.js), qui sert
 * la banque VUE DEPUIS un document — bornée à son métier.
 */

const BASE_URL = '/proposals/card_styles';

/** Retourne `{ works: [{ id, name }], card_styles: [{ id, name, props, ... }] }`. */
export const getCardStyles = async () => {
  const res = await instance.get(BASE_URL);
  return res.data;
};

// `companyWorkId` nul = modèle général, visible quel que soit le métier.
export const postCardStyle = async ({ name, props, companyWorkId = null }) => {
  const res = await instance.post(BASE_URL, { name, props, company_work_id: companyWorkId });
  return res.data;
};

/**
 * Renomme, retouche la mise en forme ou change de métier. Seules les clés
 * fournies sont écrites : un renommage ne doit pas renvoyer les props, sous
 * peine de réécrire la carte avec ce que l'écran avait en mémoire.
 */
export const patchCardStyle = async (id, { name, props, companyWorkId }) => {
  const payload = {};
  if (name !== undefined) payload.name = name;
  if (props !== undefined) payload.props = props;
  if (companyWorkId !== undefined) payload.company_work_id = companyWorkId;
  const res = await instance.patch(`${BASE_URL}/${id}`, payload);
  return res.data;
};

export const deleteCardStyle = async (id) => {
  await instance.delete(`${BASE_URL}/${id}`);
};
